import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'
import { RolesWidget } from '@/widgets/roles-widget'

const searchSchema = z.object({
  'pagination.page': z.number().default(1).optional(),
  'pagination.pageSize': z.number().default(10).optional(),
  'filter.searchByName': z.string().optional(),
})

export const Route = createFileRoute('/_auth/users/apk/roles')({
  staticData: {
    meta: {
      title: 'Роли АПК',
      description: '',
    },
  },
  validateSearch: searchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  return <RolesWidget />
}
